
export default {
    name: 'SvgPhotoCamera',
    props: {
        color: {
            type: String,
            default: '#312F2A',
        },
    },
};
